import { render } from "./TTMPropertyLogForm.vue?vue&type=template&id=a83c1c8c&scoped=true"
import script from "./TTMPropertyLogForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TTMPropertyLogForm.vue?vue&type=script&setup=true&lang=js"

import "./TTMPropertyLogForm.vue?vue&type=style&index=0&id=a83c1c8c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a83c1c8c"],['__file',"src/pages/scada/forms/TTMPropertyLogForm/TTMPropertyLogForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a83c1c8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a83c1c8c', __exports__)) {
    console.log('reload')
    api.reload('a83c1c8c', __exports__)
  }
  
  module.hot.accept("./TTMPropertyLogForm.vue?vue&type=template&id=a83c1c8c&scoped=true", () => {
    console.log('re-render')
    api.rerender('a83c1c8c', render)
  })

}


export default __exports__